<div ngbDropdown placement="left" container="body" *ngIf="isAdmin == true">
    <button class="btn btn-sm btn-uiowa-dark" ngbDropdownToggle></button>
    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <a [routerLink]="['/account', merchantAccount.id]" ngbDropdownItem *ngIf="showEditMerchantAccount">
            <fa-icon [icon]="['fas', 'edit']"></fa-icon> Edit Merchant Account
        </a>
        <button ngbDropdownItem (click)="onSetMerchantId()" *ngIf="showEditMerchantId">
            <fa-icon [icon]="['fas', 'edit']"></fa-icon> Edit {{isCashnet ? 'Location' : 'Merchant'}} ID
        </button>
        <button ngbDropdownItem (click)="onInactivate()" *ngIf="showInactivate">
            <fa-icon [icon]="['fas', 'toggle-off']"></fa-icon> Inactivate
        </button>
        <button ngbDropdownItem (click)="onActivate()" *ngIf="showActivate">
            <fa-icon [icon]="['fas', 'toggle-on']"></fa-icon>Activate
        </button>
        <button ngbDropdownItem (click)="onDelete()" *ngIf="showDelete">
            <fa-icon [icon]="['fas', 'trash']"></fa-icon> Delete
        </button>
    </div>
</div>
<a [routerLink]="['/account', merchantAccount.id]" title="Edit Merchant Account" class="btn btn-sm btn-uiowa-dark" *ngIf="isAdmin == false">
    <fa-icon [icon]="['fas', 'edit']"></fa-icon>
</a>
